<template>
  <div>
    <v-dialog v-model="value" max-width="600" scrollable persistent>
      <v-card class="pa-4">
        <div class="mb-3 d-flex justify-space-between align-center">
          <div class="popup-title">Ustawienia dostępności</div>
          <v-btn icon color="primaryBlue" @click="$emit('input', false)">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>

        <v-card-text class="pa-0" style="height: 250px;">
          <section class="frame pa-4">
            <div class="popup-row">
              <div class="popup-col">
                <v-icon class="mr-3" color="primaryBlue">
                  mdi-format-size
                </v-icon>
                <span class="popup-label" id="wcag-legend-1">
                  Wielkość tekstu:
                </span>
              </div>
              <div class="popup-col">
                <v-radio-group
                  v-model="fontSize"
                  class="ma-0 pa-0"
                  hide-details
                  aria-labelledby="wcag-legend-1"
                >
                  <v-radio
                    v-for="opt in fontSizeOptions"
                    :key="opt.value"
                    :label="opt.label"
                    :value="opt.value"
                    color="primaryBlue"
                  ></v-radio>
                </v-radio-group>
              </div>
            </div>

            <v-divider class="my-4"></v-divider>

            <div class="popup-row">
              <div class="popup-col">
                <v-icon class="mr-3" color="primaryBlue">
                  mdi-circle-slice-4
                </v-icon>
                <span class="popup-label" id="wcag-legend-2">
                  Ustawienia kontrastu:
                </span>
              </div>
              <div class="popup-col">
                <v-radio-group
                  v-model="contrast"
                  class="ma-0 pa-0"
                  hide-details
                  aria-labelledby="wcag-legend-2"
                >
                  <v-radio
                    v-for="opt in contrastOptions"
                    :key="opt.value"
                    :label="opt.label"
                    :value="opt.value"
                    color="primaryBlue"
                  ></v-radio>
                </v-radio-group>
              </div>
            </div>
          </section>
        </v-card-text>

        <div class="d-flex justify-end align-center">
          <v-btn
            depressed
            color="primaryBlue"
            rounded
            large
            dark
            @click="$emit('input', false)"
            class="ma-0 mt-4"
          >
            Zamknij
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
const fontSizeOptions = [
  { value: 1, label: "Domyślna" },
  { value: 1.1, label: "110%" },
  { value: 1.2, label: "120%" },
];

const contrastOptions = [
  { value: "default", label: "Domyślny" },
  { value: "contrast", label: "Zwiększony" },
  { value: "grey", label: "Skala szarości" },
];

export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fontSizeOptions,
      fontSize: fontSizeOptions[0].value,
      contrastOptions,
      contrast: contrastOptions[0].value,
    };
  },
  watch: {
    fontSize() {
      this.setTextSize();
    },
    contrast() {
      this.setContrast();
    },
  },
  methods: {
    setTextSize() {
      const fontSize = 16 * this.fontSize;
      document.documentElement.style.fontSize = `${fontSize}px`;
      localStorage.setItem("edb-font-size", fontSize);
    },
    setContrast() {
      if (this.contrast === "contrast") {
        document.documentElement.style.filter = "contrast(2)";
        return;
      }

      if (this.contrast === "grey") {
        document.documentElement.style.filter = "grayscale(100%)";
        return;
      }
      document.documentElement.style.filter = "";
    },
  },
};
</script>

<style lang="scss" scoped>
.frame {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
}

.popup-title {
  font-size: 1.125rem;
  font-weight: 500;
}
.popup-row {
  display: flex;
  align-items: flex-start;
}
.popup-col {
  flex: 1 0;
  display: flex;
  align-items: center;
}
.popup-label {
  font-size: 0.875rem;
  font-weight: 500;
}
</style>
